var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import axios from 'axios';
export var ApiErrorStatus;
(function (ApiErrorStatus) {
    // Returned whenever a network call reports an unauthorized request.
    // Reaction to this error should be to use the refresh-token to
    // get a new access-token, and retry whichever request that failed.
    ApiErrorStatus["InvalidAccessToken"] = "InvalidAccessToken";
})(ApiErrorStatus || (ApiErrorStatus = {}));
var DashApiError = /** @class */ (function (_super) {
    __extends(DashApiError, _super);
    function DashApiError(msg, status) {
        var _this = _super.call(this, msg) || this;
        _this.status = status;
        // Set the prototype explicitly.
        Object.setPrototypeOf(_this, DashApiError.prototype);
        return _this;
    }
    return DashApiError;
}(Error));
export { DashApiError };
var InkyDashApiV2 = /** @class */ (function () {
    function InkyDashApiV2() {
        this.baseUrl = process.env.REACT_APP_BASE_URL;
    }
    InkyDashApiV2.shared = function () {
        if (!this.instance) {
            this.instance = new InkyDashApiV2();
        }
        return this.instance;
    };
    InkyDashApiV2.prototype.FetchOrderCount = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var filters, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filters = "";
                        if (filter) {
                            filters = filter;
                        }
                        return [4 /*yield*/, this.get("/dashboard/orders/count".concat(filters))];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    InkyDashApiV2.prototype.get = function (url, params) {
        var e_1, _a;
        var fullUrl = new URL(url, this.baseUrl);
        if (params) {
            var param = void 0;
            try {
                for (var params_1 = __values(params), params_1_1 = params_1.next(); !params_1_1.done; params_1_1 = params_1.next()) {
                    param = params_1_1.value;
                    fullUrl.searchParams.append(param[0], param[1]);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (params_1_1 && !params_1_1.done && (_a = params_1.return)) _a.call(params_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return axios.get(fullUrl.href, { headers: { Authorization: "Bearer ".concat(this.AccessToken) } })
            .then(function (response) {
            return response.data;
        })
            .catch(function (error) {
            if (error.isAxiosError) {
                console.debug("Axios error response", error.response);
                if (error.response.status == 401) {
                    // Unauthorized error.
                    throw new DashApiError("Unauthorized request.", ApiErrorStatus.InvalidAccessToken);
                }
                console.log("Acioserror", error.response.status);
            }
            throw error;
        });
    };
    InkyDashApiV2.prototype.post = function (url, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var fullUrl, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fullUrl = new URL(url, this.baseUrl);
                        return [4 /*yield*/, axios.post(fullUrl.href, payload, { headers: { Authorization: "Bearer ".concat(this.AccessToken) } })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return InkyDashApiV2;
}());
export { InkyDashApiV2 };
